import toast from "react-hot-toast";

import { nextCargoApi } from "../../baseApi";
import { truckIsTruckArgsSchema } from "./truck.schema";
import { GetTruck, IsTruck, SaveDeleteTruck, SaveEditTruck, SaveNewTruck } from "./truck.types";

export const truckApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    getIsTruck: build.query<IsTruck["result"], IsTruck["args"]>({
      query: ({ plate }) => `/truck/isTruck/${plate}`,
      argSchema: truckIsTruckArgsSchema
    }),
    getTruck: build.query<GetTruck["result"], GetTruck["args"]>({
      query: ({ id }) => `/truck/${id}`,
      keepUnusedDataFor: 0,
      // transformResponse: (response) => {
      //   const normalizedRes = structuredClone(response);
      //   normalizedRes.driver.name = normalizedRes.driver.name.replace(/\s+/g, " ").trim();

      //   return normalizedRes;
      // },
      onQueryStarted: async (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Carregando caminhão...",
          success: "Caminhão carregado com sucesso!"
          // error: "Erro ao carregar caminhão."
        });
      }
    }),
    saveEditTruck: build.mutation<SaveEditTruck["result"], SaveEditTruck["args"]>({
      query: (body) => ({
        url: `/truck/app/edit`,
        method: "POST",
        body
      })
    }),
    saveNewTruck: build.mutation<SaveNewTruck["result"], SaveNewTruck["args"]>({
      query: (args) => {
        const { id = null, vehicleModel, company, driver, shippingCompany, isEnabled, ...rest } = args;

        const toNumber = (val?: string | number | null) => {
          if (val === null || val === undefined) return null;
          return typeof val === "string" ? Number(val) || null : val;
        };

        const body = {
          ...rest,
          id: id ? toNumber(id) : null,
          vehicleModel: vehicleModel?.id
            ? {
                id: toNumber(vehicleModel.id),
                truckBrand: vehicleModel.truckBrand?.id ? { id: toNumber(vehicleModel.truckBrand.id) } : undefined
              }
            : null,
          company: company?.id ? { id: toNumber(company.id) } : null,
          driver: driver?.id ? { id: toNumber(driver.id) } : null,
          shippingCompany: shippingCompany?.id ? { id: toNumber(shippingCompany.id) } : null,
          isEnabled,
          status: isEnabled
        };

        return {
          url: `/truck/save`,
          method: "POST",
          body
        };
      },
      onQueryStarted: async ({ id }, { queryFulfilled }) => {
        const isEdit = Boolean(id);
        toast.promise(queryFulfilled, {
          loading: isEdit ? "Atualizando caminhão..." : "Criando caminhão...",
          success: isEdit ? "Caminhão atualizado com sucesso!" : "Caminhão criado com sucesso!"
        });

        try {
          await queryFulfilled;
        } catch (error: unknown) {
          const err = error as { error: { data: { status: number; response: unknown; message: string } } };

          if (err.error.data.status === 502) {
            toast.error("A placa informada já está cadastrada e não pode ser utilizada.");
            return;
          }

          if (isEdit) {
            toast.error("Erro ao atualizar caminhão.");
            return;
          }

          toast.error("Erro ao criar caminhão.", { id: "create-truck-error" });
        }
      }
    }),
    saveDeleteTruck: build.mutation<SaveDeleteTruck["result"], SaveDeleteTruck["args"]>({
      query: ({ id }) => ({
        url: `/truck/delete/${id}`,
        method: "DELETE"
      }),
      onQueryStarted: async (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Excluindo caminhão...",
          success: "Caminhão excluído com sucesso!",
          error: "Erro ao excluir caminhão."
        });
      }
    })
  })
});

truckApi.enhanceEndpoints({
  addTagTypes: ["IsTruck"],
  endpoints: {
    getIsTruck: {
      providesTags: ["IsTruck"]
    },
    getTruck: {
      providesTags: (result, error, { id }) => [{ type: "Truck", id }]
    },
    saveEditTruck: {
      invalidatesTags: (result, error, { id }) => (id ? [{ type: "Truck", id }] : ["Truck"])
    },
    saveNewTruck: {
      invalidatesTags: (result, error, { id }) => (id ? [{ type: "Truck", id }] : ["Driver"])
    },
    saveDeleteTruck: {
      invalidatesTags: (result, error, { id }) => [{ type: "Truck", id }, "Driver"]
    }
  }
});
